export const config = {
  title: "JD loans & Trucking Insurance | Sacramento, CA",
  meta: {
    description:
      "JD loans & Trucking Insurance helps Sacramento businesses and individuals secure the best financing and insurance for trucks, homes, and businesses.",
    keywords: [
      "JD loans and Trucking Insurance",
      "truck insurance Sacramento",
      "home loans Sacramento",
      "commercial insurance CA",
      "financing solutions California"
    ],
    author: "JD Loans & Trucking Insurance",
    canonicalUrl: "https://jdloansandinsurance.com/",
  },
  sections: {
    header: {
      businessName: "JD Loans & Trucking Insurance",
    },
    sectionB: {
      heroTitle: "JD Loans & Trucking Insurance",
      heroSubtitle: "Reliable Loan & Insurance Solutions Across Sacramento, CA",
      learnAboutText: "Get a Quote",
      phoneNumber: "7758426418",
      phoneLabel: "(775) 842-6418",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2226919169/photo/a-truck-with-a-semi-trailer-drives-along-a-highway-against-the-backdrop-of-a-forest-in-summer.jpg?s=612x612&w=0&k=20&c=57T1ZM1Ne0iSRN_dfhE5H3fbrmwr1zj9zTwV-8sZKjo=",
      cardData: [
        {
          title: "Truck Insurance",
          description: "Specialized coverage for owner-operators and trucking companies.",
        },
        {
          title: "Home & Auto Loans",
          description: "Competitive financing for homes and vehicles.",
        },
        {
          title: "Commercial Insurance",
          description: "Protect your business with tailored insurance policies.",
        },
      ],
      description:
        "Serving the entire Sacramento region, JD loans & Trucking Insurance provides financing and insurance solutions for truckers, homeowners, and entrepreneurs.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Explore our financing and insurance options tailored for your needs—whether you're a trucker, homeowner, or business owner.",
      cards: [
        {
          title: "Truck Insurance",
          description: "Coverage for trailers, cargo, liability, and more.",
          imageSrc: "https://media.istockphoto.com/id/1813257836/photo/car-insurance-agents-inspect-and-evaluate-damaged-cars-after-accidents-recording-them-as.jpg?s=612x612&w=0&k=20&c=D4HMpHtAWUor16-xm5WWHzB_KF4EnnEChOYMJDCHrTM=",
          imageAlt: "Truck Insurance",
        },
        {
          title: "Loan Solutions",
          description: "Home and vehicle loans with flexible rates.",
          imageSrc: "https://media.istockphoto.com/id/954578184/photo/investor-working-new-startup-project.jpg?s=612x612&w=0&k=20&c=7zm4CPnmmFryIVgYtaj6tGVqNaE9xfF7-8RM2yO_ZnE=",
          imageAlt: "Loan Solutions",
        },
        {
          title: "Business Insurance",
          description: "Keep your enterprise secure with commercial policies.",
          imageSrc: "https://media.istockphoto.com/id/889031464/photo/combing-through-the-fine-print.jpg?s=612x612&w=0&k=20&c=ybKqpw2WwBS7it9Ge9DoQG8Yzih3Fc34eMXMSQMJe10=",
          imageAlt: "Business Insurance",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Fast Loan Approval",
        "Bilingual Support (English & Punjabi)",
        "Industry-Specific Coverage",
        "Trusted Across Sacramento",
        "Customer-Centric Approach"
      ],
    },
    sectionD: {
      aboutTitle: "About JD loans & Trucking Insurance",
      aboutImage: {
        src: "https://media.istockphoto.com/id/843617064/photo/business-people-or-doctor-talking-to-customer-and-using-laptop-at-office-room.jpg?s=612x612&w=0&k=20&c=M1_HnMNR03y_WOyKv0HdZXB10R9DVKjM3rhl1DWH1YA=",
        alt: "JD loans & Trucking Insurance Office",
      },
      aboutText: [
        "JD loans & Trucking Insurance is a trusted name in Sacramento for loan and insurance services. We cater to truckers, homeowners, and small businesses seeking reliable and affordable financial protection.",
        "With years of experience and a deep understanding of client needs, we offer tailored solutions and bilingual support (English & Punjabi).",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "JD loans & Trucking Insurance Logo",
      businessName: "JD loans & Trucking Insurance",
      contact: {
        phone: "7758426418",
        phoneLabel: "(775) 842-6418",
        email: "jespinder.kaur@loanfactory.com",
        website: "https://jdloansandinsurance.com/",
        address: "Whole-Sacramento, CA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Whole-Sacramento, CA, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps?q=Sacramento,+CA&output=embed",
    },
  },
};

export default config;
